import React from 'react';

const LocationUpdate = () => {
    return (
        <div>
            
        </div>
    );
};

export default LocationUpdate;